"use client";

import { Check } from "lucide-react";

interface CompletionBadgeProps {
  readonly completed: boolean;
  readonly size?: number;
}

export default function CompletionBadge({ completed, size = 18 }: CompletionBadgeProps) {
  if (!completed) return null;

  return (
    <div
      className="anim-fade-in"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--primary-light)",
        color: "var(--primary)",
        border: "1px solid var(--primary-a20)",
        borderRadius: "50%",
        width: `${size + 8}px`,
        height: `${size + 8}px`,
      }}
      title="Completed"
    >
      <Check size={size} strokeWidth={3} />
    </div>
  );
}
